import React, { createContext, useContext, useState } from 'react'

export const CommonUIContext = createContext({})

export const CommonUIContextProvider = ({ children }) => {
  const [isLoader, setIsLoader] = useState(false)
  return (
    <CommonUIContext.Provider value={{ isLoader, setIsLoader }}>
      {children}
    </CommonUIContext.Provider>
  )
}

export const useCommonUIContext = () => useContext(CommonUIContext)
